import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import MarqueeStrip from "@/components/site/MarqueeStrip";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Solutions from "@/components/site/Solutions";
import Events from "@/components/site/Events";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main className="bg-obsidian text-white antialiased" data-testid="landing-page">
      <Header />
      <Hero />
      <MarqueeStrip />
      <Manifesto />
      <Services />
      <Solutions />
      <Events />
      <Contact />
      <Footer />
    </main>
  );
}
